import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';
import LinearDeterminate from './LinearProgress';

const colors = {
    almostpaid:'#016C34',
    almostpaidbg:'#EEFCF4',
    stillowing:'#9E9018',
    stillowingbg:'#F9F8EB',
    owing: '#DC2626',
    owingbg:'#FFE2E5',

}
function createData(sn, centre, activity, rate, ) {
  return { sn, centre, activity, rate,  };
}

const rows = [
  createData('01', "Agege Skill Acquisition Centre", 60),
  createData('02',"Ikoyi Skill Acquisition Centre", 16),
  createData('03', "Idahosa Skill Acquisition Centre", 37),
];

export default function BasicTable() {
  return (
    <TableContainer component={Paper} elevation={0} >
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>S/N</TableCell>
            <TableCell align="left">Centre</TableCell>
            <TableCell  align="left">Activity</TableCell>
            <TableCell align="left">Rate&nbsp;(%)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.sn}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row?.sn}
              </TableCell>
              <TableCell align="left">{row?.centre}</TableCell>
              <TableCell sx={{width:'100px'}}align="left"><LinearDeterminate progress={row?.activity} colors={row?.activity>=50?"success": row?.activity<30? "error":"warning"}/></TableCell>
              <TableCell align="left"><Typography sx={{textAlign:'center',fontSize:'14px', padding:'5px', backgroundColor:`${row?.activity>=50?colors?.almostpaidbg: row?.activity<30?colors?.stillowingbg:colors?.owingbg}`, color:`${row.activity>=50?colors?.almostpaid: row.activity<30?colors?.stillowing:colors?.owing}`, border:`1px solid ${row.activity>=50?colors.almostpaid: row.activity<30?colors.stillowing:colors.owing}`, borderRadius:'10px'}}>{row.activity}%</Typography></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}